import "./SpirulinaCommunitySteps.css";

import FontSpirulina from "./../../font_component/spirulina_font/FontSpirulina";
import { useDispatch, useSelector } from "react-redux";
import { AllStepToJoin } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import { useEffect } from "react";

const steps = [
  {
    step: "Step 01",
    title: "Register on the Website",
    desc:
      "Create your account by signing up with your basic details on our official website.",
  },
  {
    step: "Step 02",
    title: "Purchase One Product",
    desc: "Buy one product to join the community and start your journey.",
  },
  {
    step: "Step 03",
    title: "Activate Your Account",
    desc:
      "After purchase, your account gets activated and you become eligible for referrals and rewards.",
  },
  {
    step: "Step 04",
    title: "Refer Friends & Family",
    desc:
      "Share your referral link with others. Earn ₹15 for each successful referral.",
  },
  {
    step: "Step 05",
    title: "Grow Up to Level 5",
    desc:
      "Continue referring and build your network up to 5 levels, increasing your earning opportunities accordingly.",
  },
  {
    step: "Step 06",
    title: "Order & Unlock Offers",
    desc:
      "Order higher quantities to receive more benefits, rewards, and exciting offers.",
  },
];

export default function SpirulinaCommunitySteps() {
  const dispatch = useDispatch();

  const all_step_to_join = useSelector(
    (state) => state?.common?.all_step_to_join,
  );
  console.log(all_step_to_join, "all_step_to_joinall_step_to_join");

  useEffect(() => {
    dispatch(AllStepToJoin());
  }, [dispatch]);
  return (
    <section className="steps-section">
      <div className="container">
        <h2 className="steps-heading">
          Steps To Join The{" "}
          <span>
            <FontSpirulina size="1.5rem" color="#3C9734" weight="normal">
              Spirulina
            </FontSpirulina>
          </span>{" "}
          Community
        </h2>

        <div className="steps-grid">
          {all_step_to_join.map((item, index) => (
            <div className="step-card" key={index}>
              <span className="step-number">Step:-{index + 1}</span>
              <h3>{item?.title}</h3>
              <p>{item?.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
